import { useState } from 'react';
import Button from '../../components/ui/Button';
import Input from '../../components/ui/Input';
import Select from '../../components/ui/Select';
import Modal from '../../components/ui/Modal';
import BottomSheet from '../../components/ui/BottomSheet';
import AvatarUploader from '../../components/ui/AvatarUploader';
import SettingsCard from '../../components/ui/SettingsCard';
import Toggle from '../../components/ui/Toggle';
import { Category, Section, Row } from './galleryPrimitives';

/**
 * Overlays & surfaces — modal, bottom sheet, avatar uploader, settings card.
 * Props: modal / onModalChange — shared with the gallery header Open Modal button.
 */
export default function OverlaysGallery({ modal, onModalChange }) {
  const [sheetOpen, setSheetOpen] = useState(false);
  const [on, setOn] = useState(true);

  return (
    <Category id="overlays" title="Overlays & surfaces">
      <Section name="Modal" file="components/ui/Modal.jsx">
        <Row label="trigger">
          <Button variant="primary" onClick={() => onModalChange(true)}>Open Modal</Button>
        </Row>
      </Section>

      <Section name="BottomSheet" file="components/ui/BottomSheet.jsx">
        <Row label="trigger (mobile-style sheet)">
          <Button variant="outline" onClick={() => setSheetOpen(true)}>Open Bottom Sheet</Button>
        </Row>
      </Section>

      <Section name="AvatarUploader" file="components/ui/AvatarUploader.jsx">
        <div style={{ display: 'flex', gap: '2rem', flexWrap: 'wrap' }}>
          <AvatarUploader shape="circle" initials="JD" label="photo" />
          <AvatarUploader shape="square" initials="FC" label="logo" />
        </div>
      </Section>

      <Section name="SettingsCard" file="components/ui/SettingsCard.jsx">
        <SettingsCard title="Notifications" hint="Choose how FieldCert contacts you about overdue tests.">
          <Toggle checked={on} onChange={setOn} id="sc-toggle" label="Email reminders" />
        </SettingsCard>
      </Section>

      <Modal isOpen={modal} onClose={() => onModalChange(false)} title="Record Test Result">
        <Select id="m-sel" label="Result" defaultValue="pass">
          <option value="pass">PASS</option>
          <option value="fail">FAIL</option>
        </Select>
        <Input id="m-in" label="Trip time (ms)" defaultValue="22" />
        <div style={{ display: 'flex', gap: '0.5rem', justifyContent: 'flex-end', marginTop: '1rem' }}>
          <Button variant="ghost" onClick={() => onModalChange(false)}>Cancel</Button>
          <Button variant="primary" onClick={() => onModalChange(false)}>Save Result</Button>
        </div>
      </Modal>

      <BottomSheet open={sheetOpen} onClose={() => setSheetOpen(false)}>
        <div style={{ padding: '1.25rem' }}>
          <h3 style={{ margin: '0 0 0.5rem', color: 'var(--text-primary)' }}>Asset actions</h3>
          <p style={{ margin: '0 0 1rem', color: 'var(--text-secondary)', fontSize: 'var(--text-sm)' }}>
            Scrim-click or press Esc to close.
          </p>
          <div style={{ display: 'flex', gap: '0.5rem', justifyContent: 'flex-end' }}>
            <Button variant="ghost" onClick={() => setSheetOpen(false)}>Close</Button>
          </div>
        </div>
      </BottomSheet>
    </Category>
  );
}
